import React from "react";
import { useSelector } from 'react-redux';
import './Tags.css'

function Tags() {

    const blogs = useSelector((state) => state.counter.blogs);
    let tagsSet = new Set( blogs[0].keywords)
    
    // blogs.map((blog) => {
    //     blog.keywords.forEach((item) => tagsSet.add(item))
    // })

    blogs.forEach((blog) => {
        blog.keywords.forEach((item) => tagsSet.add(item))
    })

    tagsSet= Array.from(tagsSet).sort()

    return (
        <ul className="tags">
            {tagsSet.map((tagItem,index)=>{
                const tagUri = "/posts/" + tagItem;
                return <li key={index}>
                    <a href={tagUri}>
                    {tagItem}
                    </a>
                </li>
            })}
        </ul>
    )
}

export default Tags;